import { H7 } from 'foundations-components/transitional/components/H7';
import SingleEmailInputWithControls from './SingleEmailInputWithControls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import emptyFunction from 'react-utils/emptyFunction';
import { useCallback, useId } from 'react';
import MultipleInputPopoverBodyWrapper from '../../MultipleInputPopoverBodyWrapper';
import unescapedText from 'I18n/utils/unescapedText';
import { Section } from 'foundations-components/transitional/components/Section';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { PopoverBody } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputMultipleEmailPopoverBody = ({
  additionalEmails,
  disabled,
  enablePopovers,
  inputMode,
  objectTypeId,
  onPrimaryEmailInputAdded,
  onPrimaryEmailDeleted,
  onPrimaryEmailSaved,
  onPromoteToPrimary,
  onAdditionalEmailInputAdded,
  onAdditionalEmailDeleted,
  onAdditionalEmailSaved,
  primaryEmail,
  showAutoSaveText
}) => {
  const handleEmailInputCreated = useCallback(() => {
    if (!primaryEmail) {
      onPrimaryEmailInputAdded();
    } else {
      onAdditionalEmailInputAdded();
    }
  }, [onPrimaryEmailInputAdded, onAdditionalEmailInputAdded, primaryEmail]);
  const primaryEmailLabelId = useId();
  return /*#__PURE__*/_jsx(MultipleInputPopoverBodyWrapper, {
    children: /*#__PURE__*/_jsxs(PopoverBody, {
      children: [/*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(H7, {
          "data-selenium-test": "email-input-primary-heading",
          id: primaryEmailLabelId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputMultipleEmailV2.primaryEmail"
          })
        }), primaryEmail && /*#__PURE__*/_jsx(SingleEmailInputWithControls, {
          "aria-labelledby": primaryEmailLabelId,
          disabled: disabled,
          enablePopovers: enablePopovers
          // Setting a key here ensures that the editable controls around the
          // input is automatically closed when another email is promoted to
          // primary
          ,

          isNewEmail: primaryEmail.isNewEmail,
          isOnlyEmail: additionalEmails.length === 0,
          isPrimaryEmail: true,
          objectTypeId: objectTypeId,
          onDelete: onPrimaryEmailDeleted,
          onPromoteToPrimary: emptyFunction,
          onSave: onPrimaryEmailSaved,
          value: primaryEmail,
          showAutoSaveText: showAutoSaveText,
          inputMode: inputMode
        }, primaryEmail.id)]
      }), primaryEmail && /*#__PURE__*/_jsxs(Section, {
        children: [/*#__PURE__*/_jsx(H7, {
          "data-selenium-test": "email-input-additional-heading",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataProperties.PropertyInputMultipleEmailV2.additionalEmails"
          })
        }), additionalEmails.map((email, index) => /*#__PURE__*/_jsx(SingleEmailInputWithControls, {
          "aria-label": unescapedText('customerDataProperties.PropertyInputMultipleEmailV2.additionalEmailLabel', {
            number: index + 1
          }),
          "data-test-id": `additional-email-${index + 1}`,
          marginBlockStart: "100",
          disabled: disabled,
          enablePopovers: enablePopovers,
          isOnlyEmail: false,
          isNewEmail: email.isNewEmail,
          isPrimaryEmail: false,
          objectTypeId: objectTypeId,
          onDelete: onAdditionalEmailDeleted,
          onPromoteToPrimary: onPromoteToPrimary,
          onSave: onAdditionalEmailSaved,
          value: email,
          showAutoSaveText: showAutoSaveText,
          inputMode: inputMode
        }, email.id))]
      }), /*#__PURE__*/_jsxs(Button, {
        paddingInlineStart: "0",
        paddingBlockEnd: "300",
        disabled: disabled,
        onClick: handleEmailInputCreated,
        use: "link",
        children: [/*#__PURE__*/_jsx(AddIcon, {
          size: "100",
          color: "icon-interactive-default"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataProperties.PropertyInputMultipleEmailV2.addEmail"
        })]
      })]
    })
  });
};
export default PropertyInputMultipleEmailPopoverBody;